module.exports = __webpack_public_path__ + "static/media/Contact.1a87662b.jpg";